module.exports = __webpack_public_path__ + "static/img/govcard_08.e0590a72.svg";